import { render, staticRenderFns } from "./FloatFieldtype.vue?vue&type=template&id=09e245b7&"
import script from "./FloatFieldtype.vue?vue&type=script&lang=js&"
export * from "./FloatFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports